<template>
  <div class="checkout-summary">
    <div class="summary-head">
      <div class="summary-title">Checkout Summary</div>
    </div>

    <table class="table table-bordered text-center summary-table">
      <thead class="thead-light">
        <tr>
          <th>Item</th>
          <th class="qty-col">Qty</th>
          <th class="total-col">Total</th>
        </tr>
      </thead>

      <tbody>
        <tr
          v-for="(fnbitem, fnbitemKey) in safeFnbList"
          :key="'item_' + fnbitemKey"
        >
          <td class="text-left">
            <template v-if="getShowForItem(fnbitem)">
              <div class="item-movie-title">
                {{ formatMovieHeader(getShowForItem(fnbitem)) }}
              </div>
              <div
                v-if="formatShowDateTime(getShowForItem(fnbitem))"
                class="item-movie-meta"
              >
                {{ formatShowDateTime(getShowForItem(fnbitem)) }}
              </div>
              <div class="item-seat-line">
                {{ formatSeatLine(fnbitem, getShowForItem(fnbitem)) }}
              </div>
            </template>
            <div v-else class="item-name">{{ fnbitem.item_name }}</div>
            <div v-if="comboLines(fnbitem).length" class="detail-line">
              {{ comboText(fnbitem) }}
            </div>
            <div v-if="addonLines(fnbitem).length" class="detail-line addon-line">
              {{ addonText(fnbitem) }}
            </div>
          </td>
          <td>{{ fnbitem.quantity }}</td>
          <td class="text-right">
            <div>{{ formatAmount(lineAmount(fnbitem, "fp_total_amount")) }}</div>
            <div v-if="addonGross(fnbitem)" class="detail-line">
              +{{ formatAmount(addonGross(fnbitem)) }}
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="totals">
      <div v-if="!isIraqClient" class="total-row">
        <span>Sub Total</span>
        <strong>{{ formatAmount(subTotal) }}</strong>
      </div>
      <div v-if="!isIraqClient" class="total-row">
        <span>Tax</span>
        <strong>{{ formatAmount(grossTotal - subTotal) }}</strong>
      </div>
      <div v-if="RateCardAddonsChargesFinalAmount > 0" class="total-row">
        <span>Additional Charges</span>
        <strong>{{ formatAmount(RateCardAddonsChargesFinalAmount || 0) }}</strong>
      </div>
      <div
        v-for="(deduction, deductionIndex) in deductionArray || []"
        :key="'deduction_' + deductionIndex"
        class="total-row discount"
      >
        <span>{{ deduction.deduction_name }}</span>
        <strong>-{{ formatAmount(deduction.amount) }}</strong>
      </div>
      <div
        v-for="(splitObj, splitIndex) in splitPaymentModes || []"
        :key="'split_' + splitIndex"
        class="total-row"
      >
        <span>{{ splitObj.pm_payment_mode }}</span>
        <strong>{{ formatAmount(splitObj.amount) }}</strong>
      </div>
      <div v-if="Number(change_amount) > 0" class="total-row">
        <span>Change</span>
        <strong>{{ formatAmount(change_amount || 0) }}</strong>
      </div>
      <div class="total-row gross">
        <span>Gross Total</span>
        <strong>{{ formatAmount(grossFinalAmt) }}</strong>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: {
    fnbList: {
      type: Array,
    },
    splitPaymentModes: {
      type: Array,
    },
    change_amount: {
      type: String,
      default: "0",
    },
    deductionArray: {
      type: Array,
    },
    fnbtotalamount: {
      type: Number,
    },
    currCode: {
      type: String,
    },
    charges: {
      type: Array,
    },
    showDataArr: {
      type: Array,
    },
    offerData: {
      type: Array,
    },
    RateCardAddonsChargesFinalAmount: {
      type: Number,
    },
    finalAmountToPay: {
      type: Number,
    },
    addonArray: {
      type: Array,
    },
  },
  methods: {
    lineAmount(item, field) {
      const value = Number(item && item[field]);
      const quantity = Number(item && item.quantity);
      if (!isFinite(value) || !isFinite(quantity)) return 0;
      return value * quantity;
    },
    comboLines(item) {
      const lines = [];
      const packs = item && Array.isArray(item.combo_pack) ? item.combo_pack : [];
      packs.forEach((category) => {
        const comboItems =
          category && Array.isArray(category.combo_items)
            ? category.combo_items
            : [];
        comboItems.forEach((comboItem) => {
          if (!comboItem) return;
          const quantity = Number(comboItem.quantity || 0);
          if (!isFinite(quantity) || quantity <= 0) return;
          lines.push({
            name: comboItem.item_name || "",
            quantity,
          });
        });
      });
      return lines;
    },
    addonLines(item) {
      const lines = [];
      const addons =
        item && Array.isArray(item.customizations) ? item.customizations : [];
      addons.forEach((addon) => {
        if (!addon) return;
        const quantity = Number(addon.quantity || 0);
        if (!isFinite(quantity) || quantity <= 0) return;
        const rate = Number(addon.fp_total_amount || addon.fp_amount || 0);
        const safeRate = isFinite(rate) ? rate : 0;
        const net = Number(
          addon.fp_amount != null ? addon.fp_amount : safeRate
        );
        const safeNet = isFinite(net) ? net : 0;
        lines.push({
          name: addon.item_name || "",
          quantity,
          rate: safeRate,
          amount: safeRate * quantity,
          netAmount: safeNet * quantity,
        });
      });
      return lines;
    },
    addonGross(item) {
      return this.addonLines(item).reduce(
        (total, line) => total + (Number(line.amount) || 0),
        0
      );
    },
    addonNet(item) {
      return this.addonLines(item).reduce(
        (total, line) => total + (Number(line.netAmount) || 0),
        0
      );
    },
    comboText(item) {
      return this.comboLines(item)
        .map((line) => line.name + " x" + line.quantity)
        .join(" · ");
    },
    addonText(item) {
      return this.addonLines(item)
        .map(
          (line) =>
            line.name +
            " x" +
            line.quantity +
            " @ " +
            this.currFormat(line.rate) +
            " = " +
            this.currFormat(line.amount)
        )
        .join(" · ");
    },
    formatAmount(amount) {
      const formatted = this.currFormat(parseFloat(amount || 0));
      return this.currencyLabel
        ? `${formatted} ${this.currencyLabel}`
        : formatted;
    },
    getShowForItem(item) {
      if (!item || !this.showDataArr || !this.showDataArr.length) {
        return null;
      }
      const itemName = item.item_name || "";
      const byTitle = this.showDataArr.find(
        (show) =>
          show.movie_name && itemName.startsWith(String(show.movie_name))
      );
      if (byTitle) {
        return byTitle;
      }
      if (item.sst_id !== undefined && this.showDataArr.length === 1) {
        return this.showDataArr[0];
      }
      return null;
    },
    formatMovieHeader(show) {
      if (!show) {
        return "";
      }
      const parts = [show.movie_name];
      if (show.mf_lang_name) {
        parts.push(show.mf_lang_name);
      }
      if (show.rating) {
        parts.push(show.rating);
      }
      let header = parts.join(" - ");
      if (show.screen_name) {
        header += ` | ${show.screen_name}`;
      }
      return header;
    },
    formatShowDate(dateValue) {
      if (!dateValue) {
        return "";
      }
      const value = String(dateValue);
      if (!value.includes("T") && !/^\d{4}-\d{2}-\d{2}/.test(value)) {
        return value;
      }
      const parsed = moment(value);
      if (parsed.isValid()) {
        return parsed.format("ddd, Do MMM, YYYY");
      }
      return value;
    },
    formatShowTime(timeValue) {
      if (!timeValue) {
        return "";
      }
      const value = String(timeValue);
      const parsed = moment(value, ["HH:mm:ss", "HH:mm", "hh:mm A"], true);
      if (parsed.isValid()) {
        return parsed.format("HH:mm");
      }
      if (value.includes("T")) {
        const asDate = moment(value);
        if (asDate.isValid()) {
          return asDate.format("HH:mm");
        }
      }
      return value;
    },
    formatShowDateTime(show) {
      if (!show) {
        return "";
      }
      const date = this.formatShowDate(show.ss_start_date);
      const time = this.formatShowTime(show.ss_start_show_time);
      if (date && time) {
        return `${date} · ${time}`;
      }
      return date || time || "";
    },
    formatSeatLine(item, show) {
      const itemName = item.item_name || "";
      if (show && show.movie_name && itemName.startsWith(show.movie_name)) {
        return itemName
          .slice(show.movie_name.length)
          .replace(/^\s*-\s*/, "")
          .trim();
      }
      return itemName;
    },
  },
  computed: {
    isIraqClient() {
      let hostname = window.location.hostname;
      return hostname.includes("iraq") || hostname.includes("irq");
    },
    safeFnbList() {
      return Array.isArray(this.fnbList) ? this.fnbList.filter(Boolean) : [];
    },
    movieLine() {
      const show = Array.isArray(this.showDataArr) ? this.showDataArr[0] : null;
      if (!show) return "";
      const parts = [show.movie_name, show.mf_lang_name, show.rating, show.screen_name]
        .filter(Boolean)
        .map((part) => String(part));
      const unique = [];
      parts.join(" - ").split(/,\s*/).forEach((bit) => {
        const text = bit.trim();
        if (text && unique.indexOf(text) === -1) unique.push(text);
      });
      return unique.join(" · ");
    },
    subTotal() {
      return this.safeFnbList.reduce(
        (total, item) =>
          total + this.lineAmount(item, "fp_amount") + this.addonNet(item),
        0
      );
    },
    grossFinalAmt() {
      const amount = parseFloat(this.finalAmountToPay);
      return (isFinite(amount) ? amount : 0).toFixed(2);
    },
    offerDiscountTotal() {
      const offerData = this.offerData || [];
      return offerData.reduce(
        (sum, offer) => sum + parseFloat(offer.offer_price || 0),
        0
      );
    },
    grossTotal() {
      const RateCardAddonsChargesFinalAmount = this
        .RateCardAddonsChargesFinalAmount
        ? this.RateCardAddonsChargesFinalAmount
        : 0;

      return (
        this.safeFnbList.reduce(
          (total, item) =>
            total +
            this.lineAmount(item, "fp_total_amount") +
            this.addonGross(item),
          0
        ) +
        RateCardAddonsChargesFinalAmount -
        this.offerDiscountTotal
      );
    },
    currencyLabel() {
      return (
        this.currCode ||
        this.$store.getters.GET_CURRENCY ||
        (this.$store.getters.getFnBCurrency &&
          this.$store.getters.getFnBCurrency.curr_code) ||
        ""
      );
    },
  },
};
</script>

<style scoped>
.checkout-summary {
  height: 100vh;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  background: #fff;
  padding: 6px 8px 8px;
  overflow: hidden;
}

.summary-head {
  flex: 0 0 auto;
  text-align: center;
  margin-bottom: 4px;
}

.summary-title {
  font-size: 16px;
  font-weight: 700;
  line-height: 1.1;
}

.summary-table {
  width: 100%;
  margin-bottom: 4px;
}

.summary-table th,
.summary-table td {
  font-size: 12px;
  line-height: 1.15;
  vertical-align: middle;
  padding: 2px 6px !important;
}

.qty-col {
  width: 52px;
}

.total-col {
  width: 78px;
}

.item-name {
  font-weight: 600;
}

.detail-line {
  color: #666;
  font-size: 11px;
  font-weight: 400;
  line-height: 1.2;
  white-space: normal;
}

.addon-line {
  color: #5b467f;
}

.totals {
  flex: 0 0 auto;
  border-top: 1px solid #222;
  padding-top: 4px;
}

.total-row {
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  font-size: 12px;
  line-height: 1.3;
}

.total-row strong {
  min-width: 72px;
  text-align: right;
}

.total-row.discount {
  color: #c0392b;
}

.total-row.gross {
  margin-top: 2px;
  font-size: 15px;
  font-weight: 700;
}

.total-row.gross strong {
  color: #1e7e34;
}

.item-movie-title {
  font-weight: 600;
  line-height: 1.2;
}

.item-movie-meta,
.item-seat-line {
  color: #666;
  font-size: 11px;
  line-height: 1.2;
}
</style>
